
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { PrimeNGConfig } from 'primeng/api';
import { LayoutService, AppConfig } from 'src/app/layout/service/app.layout.service';
import { MenuService } from 'src/app/layout/app.menu.service';

import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],

})
export class AppComponent implements OnInit, OnDestroy {
  title = 'WebYTO: Продажі, Управління запасами та складами, CRM та взаємодія з клієнтами';
  constructor(private primengConfig: PrimeNGConfig, private layoutService: LayoutService, public menuService: MenuService, private titleService: Title) {
    environment.production || console.log('*** AppComponent calling LayoutService constructor');
}

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    // Set browser window title FIRST
    this.titleService.setTitle(this.title);

    const savedConfig = this.layoutService.getInitialConfig();

    environment.production || console.log('*** AppComponent in ngOnInit loading LayoutService saved config: ', JSON.stringify(savedConfig));

    this.primengConfig.ripple = savedConfig.ripple;

    this.layoutService.config.set(savedConfig);

    //optional configuration with the default configuration
    // this.primengConfig.ripple = true;       //enables core ripple functionality
       
    //const config: AppConfig = {
    //  ripple: false,                      // toggles ripple on and off
    //  inputStyle: 'outlined',             // default style for input elements
    //  menuMode: 'static',                 // layout mode of the menu, valid values are "static", "overlay", "slim", "horizontal", "drawer" and "reveal"
    //  colorScheme: 'light',               // color scheme of the template, valid values are "light" and "dark"
    //  componentTheme: 'indigo',           // default component theme for PrimeNG
    //  scale: 12,                           // size of the body font size to scale the whole application
    //  menuTheme: 'green',                  // theme of the menu
    //  topbarTheme: 'teal',                // theme of the topbar
    //  menuProfilePosition: 'start',          // position of the profile menu inside the main menu, valid values are "start" and "end"
    //};

    //this.layoutService.config.set(config);

  }
}
